/**
 * Did this failure happen because the request never got an answer?
 *
 * True only for a transport-level axios failure — a timeout, a dropped
 * connection, DNS, an offline device. False for anything the server actually
 * answered (any status at all), and false for a failure that never involved a
 * request in the first place (crypto, IndexedDB, a contract violation thrown by
 * our own code), which is why it tests for an axios error rather than merely
 * for a missing status.
 *
 * `cause` is checked as well as the error itself because both shapes reach the
 * init path: `getKeyStatus` wraps its axios error in a user-facing Error and
 * attaches the original as `cause`, while `unlockDek`/`serverWrapDek` propagate
 * the raw axios error.
 */
export default function isUnreachableError(error) {
  const axiosError = [error, error?.cause].find((e) => e?.isAxiosError);
  return !!axiosError && !axiosError.response;
}
